import { deserializeHTMLElement } from './deserializeHTMLElement.mjs';

/**
 * Deserialize HTML to a valid Slate value.
 */
function deserializeHTMLToDocument({
  plugins,
  element
}) {
  const nodes = deserializeHTMLElement({
    plugins,
    element
  });

  // The document always has a single root node that contains the children of the document
  return [{
    children: nodes
  }];
}

export { deserializeHTMLToDocument };
